import {
  defaultUploadAllVendorColumns,
  defaultUploadSupplierColumns,
  defaultUploadSupplierDetailColumns,
  defaultMasterVendorColumns,
  defaultChildSupplierColumns,
  defaultAllCardColumns,
  defaultAllPaymentColumns,
  defaultAllMerchantColumns,
  defaultMasterSupplierColumns,
  defaultMasterSupplierColumnsRight,
  defaultDataSources,
  defaultSideMenus,
  defaultRelatedSupplierColumns,
  defaultAllSupplierColumns,
  defaultMasterSupplierTableColumns,
  createSupplierTabs,
  createSupplierBasicColumns,
  createSupplierAchColumns,
  createSupplierCardColumns,
  createSupplierCheckColumns,
  notParsedAddressColumns,
  listExportColumns,
  supplierMatchColumns,
  paymentOptimizationColumns,
  rwConfigurationColumns
} from '../../utils/constants/defaultValues'

import {
  APP_START,
  BULK_EDITOR_PANE_TOGGLE,
  UPDATE_DATA_SOURCE,
  SET_SPEND_DURATION,
} from '../actionTypes/app.js'

import {
  countryISOList,
  stateCodesList
} from '../../utils/countryISO/countryISO'

// The initial state of the App
export const initialState = {
  loading: false,
  createLoading: false,
  error: false,
  appState: 'NOT_STARTED',
  showBulkEditorPane: false,
  uploadAllVendorColumns: defaultUploadAllVendorColumns,
  uploadSupplierColumns: defaultUploadSupplierColumns,
  uploadSupplierDetailColumns: defaultUploadSupplierDetailColumns,
  masterColumns: defaultMasterVendorColumns,
  childSupplierColumns: defaultChildSupplierColumns,
  cardColumns: defaultAllCardColumns,
  paymentColumns: defaultAllPaymentColumns,
  merchantColumns: defaultAllMerchantColumns,
  masterSupplierColumns: defaultMasterSupplierColumns,
  masterSupplierColumnsRight: defaultMasterSupplierColumnsRight,
  relatedSupplierColumns: defaultRelatedSupplierColumns,
  supplierAllColumns: defaultAllSupplierColumns,

  dataSources: defaultDataSources,
  sideMenus: defaultSideMenus,
  currentDataSource: null,
  spendTimeFrame: null,
  spendTimeType: null,
  masterSupplierTableColumns: defaultMasterSupplierTableColumns,
  createSupplierTabs,
  createSupplierBasicColumns,
  createSupplierAchColumns,
  createSupplierCardColumns,
  createSupplierCheckColumns,
  notParsedAddressColumns,
  countryISOList,
  stateCodesList,
  listExportColumns,
  supplierMatchColumns,
  paymentOptimizationColumns,
  rwConfigurationColumns
}

const app = (state = initialState, action) => {
  switch (action.type) {
    case APP_START:
      return {
        ...state,
        appState: 'INITIALIZING',
      };
    case BULK_EDITOR_PANE_TOGGLE:
      return {
        ...state,
        showBulkEditorPane: !state.showBulkEditorPane
      }
    case UPDATE_DATA_SOURCE:
      return {
        ...state,
        currentDataSource: action.data,
      }
    case SET_SPEND_DURATION:
      return {
        ...state,
        spendTimeFrame: action.data.spendTimeFrame,
        spendTimeType: action.data.spendTimeType,
      }
    default:
      return state
  }
}

export default app
